import { render } from "./booking-menu.vue?vue&type=template&id=338e9c1c&scoped=true"
import script from "./booking-menu.vue?vue&type=script&lang=js"
export * from "./booking-menu.vue?vue&type=script&lang=js"

import "./booking-menu.vue?vue&type=style&index=0&id=338e9c1c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338e9c1c"]])

export default __exports__